import { getLabelMessage } from '@gef-ui/localization/messages';

import { isDateWithOrder, isFullySpecifiedDate } from 'app/forms/validations/common';
import isNumber from 'app/forms/validations/isNumber';
import isPolicyNo from 'app/forms/validations/isPolicyNo';
import { COMMON_FORM_FIELD_NAMES } from 'features/common/forms/constants';

export const PRODUCED_PRODUCTION_FILTER_FORM_NAME = 'producedProduction-filter';

const { channel, region, agency, manager, seller, ppz, policyNumber, documentType } = COMMON_FORM_FIELD_NAMES;

export const FIELDS = {
	channel,
	region,
	agency,
	manager,
	seller,
	ppz,
	policyNumber,
	documentType,
	scan: 'scan',
	reportDateFrom: 'reportDateFrom',
	reportDateTo: 'reportDateTo',
	withoutPpz: 'withoutPpz',
};

export default () => ({
	[FIELDS.channel]: {
		deepPath: [FIELDS.channel],
		validations: [],
	},
	[FIELDS.region]: {
		deepPath: [FIELDS.region],
		validations: [],
	},
	[FIELDS.agency]: {
		deepPath: [FIELDS.agency],
		validations: [],
	},
	[FIELDS.manager]: {
		deepPath: [FIELDS.manager],
		validations: [],
	},
	[FIELDS.seller]: {
		deepPath: [FIELDS.seller],
		validations: [],
	},
	[FIELDS.ppz]: {
		deepPath: [FIELDS.ppz],
		validations: [],
	},
	[FIELDS.policyNumber]: {
		deepPath: [FIELDS.policyNumber],
		validations: [isNumber({ customMessage: getLabelMessage('validation:allowedCharacters') }), isPolicyNo()],
	},
	[FIELDS.documentType]: {
		deepPath: [FIELDS.documentType],
		validations: [],
	},
	[FIELDS.scan]: {
		deepPath: [FIELDS.scan],
		validations: [],
	},
	[FIELDS.reportDateFrom]: {
		deepPath: [FIELDS.reportDateFrom],
		dependentFields: [FIELDS.reportDateTo],
		validations: [
			isFullySpecifiedDate(),
			isDateWithOrder({ fromFieldName: FIELDS.reportDateFrom, toFieldName: FIELDS.reportDateTo }),
		],
	},
	[FIELDS.reportDateTo]: {
		deepPath: [FIELDS.reportDateTo],
		dependentFields: [FIELDS.reportDateFrom],
		validations: [
			isFullySpecifiedDate(),
			isDateWithOrder({ fromFieldName: FIELDS.reportDateFrom, toFieldName: FIELDS.reportDateTo }),
		],
	},
	[FIELDS.withoutPpz]: {
		deepPath: [FIELDS.withoutPpz],
		validations: [],
	},
});
